import { apiFetch } from "./CommonApi";

export const loadProducts = (param) => {
  const url = param ? `service/products/?${param}` : "service/products/?page=1";
  return apiFetch("GET", url, null, true).then((res) => {
    // console.log(res.result);
    if (res.ok) {
      return res.json();
    } else {
      // navigate("/login");
    }
  });
};

export const createProduct = (data) => {
  const formData = new FormData();

  const appendData = (formData, data) => {
    Object.keys(data).forEach((key) => {
      // Skip 'file' and 'fileName' as we handle them separately
      if (key !== "file" && key !== "fileName") {
        // Only append if the value exists to avoid sending "undefined" strings
        if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      }
    });
  };

  if ("file" in data && data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName);

        appendData(formData, data);
        formData.append("image", file);
        formData.append("imageName", data.fileName);
        // console.log(Object.fromEntries(formData));
        return apiFetch("POST", "service/products/", formData, true);
      });
  } else {
    appendData(formData, data);
    return apiFetch("POST", "service/products/", formData, true);
  }
};

// export const editProduct = (editId, data) => {
//   const body = {
//     id: editId,
//     name: data.name.toLowerCase().replace(/ /g, "_"),
//   };

//   return apiFetch("PUT", `/service/products/${editId}/`, body, true);
// };

export const editProduct = (editId, data) => {
  const formData = new FormData();

  const appendData = (formData, data) => {
    Object.keys(data).forEach((key) => {
      if (key !== "file" && key !== "fileName") {
        if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      }
    });
  };

  formData.append("id", editId);
  if ("file" in data && data.file) {
    return fetch(data.file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], data.fileName);

        appendData(formData, data);
        formData.append("image", file);
        formData.append("imageName", data.fileName);
        // console.log("Edit Product formData",Object.fromEntries(formData));
        return apiFetch("PUT", `service/products/${editId}/`, formData, true);
      });
  } else {
    appendData(formData, data);
    return apiFetch("PUT", `service/products/${editId}/`, formData, true);
  }
};

export const delProduct = (productId) => {
  return apiFetch("DELETE", `service/products/${productId}/`, null, true).then(
    (res) => {
      if (res.ok) {
        return true;
      }
    }
  );
};

export const syncCatalogAndProducts = (wabaId, productIds, catalogName = null) => {
  const url = `whatsapp-business/catalog/${wabaId}/sync-catalog/`;
  const body = {
    product_ids: productIds,
    catalog_name: catalogName,
  };

  return apiFetch("POST", url, body, true).then((res) => {
    if (res.ok) return res.json();
    throw new Error("Failed to initiate catalog sync");
  });
};